enum OrderDeliveryType {
  Pickup = 2,
  Delivery = 1
}

export default OrderDeliveryType
